/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sort_DescInputs */

const en_sort_desc = /** @type {(inputs: Sort_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Z → A`)
};

const ko_sort_desc = /** @type {(inputs: Sort_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Z → A`)
};

const ja_sort_desc = /** @type {(inputs: Sort_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Z → A`)
};

/**
* | output |
* | --- |
* | "Z → A" |
*
* @param {Sort_DescInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const sort_desc = /** @type {((inputs?: Sort_DescInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sort_DescInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sort_desc(inputs)
	if (locale === "ko") return ko_sort_desc(inputs)
	return ja_sort_desc(inputs)
});